module.exports = __webpack_public_path__ + "static/img/celoscope-detail-21.601e2ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-21.jpg
// module id = ig3f
// module chunks = 52